import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(registrationVerifyEmail);

    /** @ngInject */
    function registrationVerifyEmail($stateProvider) {
        $stateProvider.state('verifyAccount', {
            url: '/auth/registration/confirm/:token/',
            template:
                require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/auth/registration/verify_email/verify_email.html'),
            controller: 'RegistrationVerifyEmailController',
            controllerAs: 'RegistrationVerifyEmailCtrl',
        });
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/auth/registration/verify_email/verify_email.route.ts